import React from "react";
import { ListGroup, ListGroupItem, Badge } from "reactstrap";
import { ContentLoader } from "../../../../components/Common";
import { INTEGRATION_PROVIDERS } from "../constants";

/**
 * IntegrationSidebar
 * Sidebar com as integrações disponíveis (OpenAI, Gemini, Evolution API).
 */
const IntegrationSidebar = ({ integrations, activeProviderId, onSelect, loading, evolutionStatus }) => {
    if (loading) {
        return (
            <div className="border border-top rounded-0 h-100 overflow-hidden bg-white">
                <ContentLoader />
            </div>
        );
    }

    const totalActive = INTEGRATION_PROVIDERS.filter(
        (p) => integrations[p.id]?.isActive
    ).length;

    return (
        <div className="border border-top rounded-0 h-100 overflow-hidden bg-white d-flex flex-column">
            <div className="bg-white border-bottom py-3 px-4">
                <div className="d-flex align-items-start overflow-hidden">
                    <i className="mdi mdi-puzzle-outline text-primary font-size-22 me-2 mt-1"></i>
                    <div className="overflow-hidden">
                        <h6 className="mb-0 fw-bold text-dark text-truncate">
                            Integrações
                        </h6>
                        <p className="text-muted small mb-0 text-truncate">
                            {totalActive} de {INTEGRATION_PROVIDERS.length} ativas
                        </p>
                    </div>
                </div>
            </div>

            <ListGroup flush className="flex-grow-1 overflow-auto custom-scrollbar">
                {INTEGRATION_PROVIDERS.map((provider) => {
                    const isActive = activeProviderId === provider.id;
                    const isConfigured = !!integrations[provider.id]?.isActive;

                    return (
                        <ListGroupItem
                            key={provider.id}
                            tag="button"
                            action
                            onClick={() => onSelect(provider.id)}
                            className={`border-0 py-3 px-4 d-flex align-items-center justify-content-between transition-all select-none cursor-pointer rounded-0 ${isActive ? "bg-primary bg-opacity-10" : "hover-bg-light"
                                }`}
                            style={{
                                borderLeft: isActive
                                    ? "4px solid var(--bs-primary)"
                                    : "4px solid transparent"
                            }}
                        >
                            <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div className="flex-shrink-0 me-3">
                                    <i className={`mdi ${provider.icon} font-size-20`} style={{ color: provider.color, marginTop: '2px' }}></i>
                                </div>
                                <div className="text-start overflow-hidden">
                                    <h6
                                        className={`mb-0 fw-semibold text-truncate font-size-14 ${isActive ? "text-primary" : "text-dark"
                                            }`}
                                    >
                                        {provider.name}
                                    </h6>
                                    <span
                                        className="text-muted small"
                                        style={{ fontSize: "11px" }}
                                    >
                                        {provider.description.substring(0, 42)}...
                                    </span>
                                </div>
                            </div>

                            <div className="d-flex align-items-center gap-2 flex-shrink-0">
                                {provider.id === "evolution" && evolutionStatus && (
                                    <span
                                        title={evolutionStatus === "open" ? "Online" : evolutionStatus === "close" ? "Offline" : "Verificando..."}
                                        style={{
                                            width: 8,
                                            height: 8,
                                            borderRadius: "50%",
                                            backgroundColor: evolutionStatus === "open" ? "#34c759" : evolutionStatus === "checking" ? "#8e8e93" : "#ff3b30",
                                            boxShadow: evolutionStatus === "open" ? "0 0 6px #34c759" : "none",
                                        }}
                                    />
                                )}
                                {isConfigured && (
                                    <Badge
                                        color="success"
                                        pill
                                        className="bg-opacity-10 text-success font-size-10 px-2 rounded-0"
                                        style={{ backgroundColor: "transparent" }}
                                    >
                                        Ativa
                                    </Badge>
                                )}
                            </div>
                        </ListGroupItem>
                    );
                })}
            </ListGroup>
        </div>
    );
};

export default IntegrationSidebar;
